import React from 'react'
import AdminNavbar from "../Navbars/AdminNavbar";
import Sidebar from "../Sidebar/Sidebar.jsx";
import { SuperAdminApis } from '../../apis/superAdminApi';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { convertUTCDateToLocalDate } from '../Reusable/functions';
import AdminSidebar from '../Sidebar/AdminSidebar';
//@ts-ignore
import Modal from 'react-awesome-modal';
import { SvgElement, icontypesEnum } from '../assets/svgElement';
import { ToastContainer, toast } from 'react-toastify';
import { Oval } from 'react-loader-spinner';

function ManageExpense() {
  let [invoiceModal, setInvoiceModal] = React.useState<boolean>(false);
  let [reportModal, setReportModal] = React.useState<boolean>(false);
  let [exportModal, setExportModal] = React.useState<boolean>(false);

  const navigate = useNavigate();
  const [userLists, setUserList] = React.useState<any>([]);
  const [searchText, setSearchText] = React.useState('');
  const [from, setFrom] = React.useState('');
  const [to, setTo] = React.useState('');
  const [loader, setLoader] = React.useState<boolean>(false);

  const [fromDate, setFromDate] = React.useState('');
  const [toDate, setToDate] = React.useState('');
  const [userEmail, setUserEmail] = React.useState('');

  // Report generation states
  const [reportType, setReportType] = React.useState('monthly');
  const [reportMonth, setReportMonth] = React.useState('');
  const [reportYear, setReportYear] = React.useState(new Date().getFullYear().toString());
  const [customFromDate, setCustomFromDate] = React.useState('');
  const [customToDate, setCustomToDate] = React.useState('');

  // Export states
  const [exportFormat, setExportFormat] = React.useState('csv');
  const [exportFromDate, setExportFromDate] = React.useState('');
  const [exportToDate, setExportToDate] = React.useState('');

  React.useEffect(() => {
    loadExpenseData();
  }, []);

  const loadExpenseData = () => {
    const query: any = {
      search: searchText,
      from: from,
      to: to
    };
    setLoader(true);
    SuperAdminApis.getAllExpense('', query).then(
      (response: AxiosResponse<any>) => {
        if (response?.data) {
          setUserList(response?.data?.data)
          setLoader(false);
          console?.log(response?.data?.data)
        }
      }
    ).catch(function (error) {
      setLoader(false);
      console.error('Error loading expense data:', error);
    })
  };

  const paginator = React.useCallback(
    (value: any) => {
      let value2 = '';
      if (value !== null) {
        value2 = value;
      } else {
        value2 = ''
      }
      const query: any = {
        search: searchText,
        from: from,
        to: to
      };

      setLoader(true);
      SuperAdminApis.getAllExpense(value2, query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data) {
            setUserList(response?.data?.data)
            setLoader(false);
            console?.log(response?.data?.data)
          }
        }
      ).catch(function (error) {
        setLoader(false);
        console.log(error.response.data);
      })

    }, [userLists, searchText, from, to]);

  const generateInvoice = React.useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const query: any = {
        date_from: fromDate,
        date_to: toDate,
        email: userEmail
      };

      SuperAdminApis.sendInvoice(query).then(
        (response: AxiosResponse<any>) => {
          if (response?.data?.status) {
            toast.success("Invoice Sent to Customer")
            setInvoiceModal(false)
          } else {
            toast.error("Invoice not valid for the date range")
            setInvoiceModal(false)
          }
        }
      ).catch(function (error) {
        toast.error("Failed to send invoice");
        console.error(error);
      })
    }, [fromDate, toDate, userEmail, invoiceModal]);

  // Generate Monthly Report
  const generateReport = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);

    let startDate = '';
    let endDate = '';

    if (reportType === 'monthly') {
      if (!reportMonth || !reportYear) {
        toast.error('Please select month and year for monthly report');
        setLoader(false);
        return;
      }
      const month = reportMonth.padStart(2, '0');
      startDate = `${reportYear}-${month}-01`;
      const lastDay = new Date(parseInt(reportYear), parseInt(reportMonth), 0).getDate();
      endDate = `${reportYear}-${month}-${lastDay}`;
    } else if (reportType === 'custom') {
      if (!customFromDate || !customToDate) {
        toast.error('Please select date range for custom report');
        setLoader(false);
        return;
      }
      startDate = customFromDate;
      endDate = customToDate;
    }

    const query = {
      search: '',
      from: startDate,
      to: endDate,
      limit: 50000 // High limit for reports
    };

    // Use the new export endpoint for reports too
    SuperAdminApis.exportAllExpenses(query).then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        const expenseData = response?.data?.data || [];

        if (expenseData.length === 0) {
          toast.warning('No data found for the selected date range');
          setLoader(false);
          setReportModal(false);
          return;
        }

        generateReportHTML(expenseData, startDate, endDate);
        setLoader(false);
        setReportModal(false);
        toast.success(`Report generated successfully with ${expenseData.length} records`);
      } else {
        setLoader(false);
        toast.error('No data available for report generation');
        setReportModal(false);
      }
    }).catch((error) => {
      setLoader(false);
      console.error('Report generation error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to generate report';
      toast.error(errorMessage);
      setReportModal(false);
    });
  }, [reportType, reportMonth, reportYear, customFromDate, customToDate]);

  // Generate Report HTML
  const generateReportHTML = (data: any[], startDate: string, endDate: string) => {
    const totalAmount = data.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
    const reportTitle = reportType === 'monthly'
      ? `Monthly Expense Report - ${reportMonth}/${reportYear}`
      : `Custom Expense Report - ${startDate} to ${endDate}`;

    const reportHTML = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${reportTitle}</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .header { text-align: center; margin-bottom: 30px; }
          .summary { background-color: #f5f5f5; padding: 15px; margin-bottom: 20px; border-radius: 5px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          th { background-color: #f2f2f2; }
          .total-row { background-color: #e8f5e8; font-weight: bold; }
          @media print { body { margin: 0; } }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>${reportTitle}</h1>
          <p>Generated on: ${new Date().toLocaleDateString()}</p>
        </div>
        
        <div class="summary">
          <h3>Summary</h3>
          <p><strong>Period:</strong> ${startDate} to ${endDate}</p>
          <p><strong>Total Expenses:</strong> ${data.length} transactions</p>
          <p><strong>Total Amount:</strong> ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(totalAmount)}</p>
        </div>

        <table>
          <thead>
            <tr>
              <th>S/N</th>
              <th>Invoice ID</th>
              <th>Expense Type</th>
              <th>Email</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            ${data.map((item, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${item.invoice_id || 'N/A'}</td>
                <td>${item.shipment_id || 'N/A'}</td>
                <td>${item.user_email || 'N/A'}</td>
                <td>${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(parseFloat(item.amount) || 0)}</td>
                <td>${item.payment_status || 'N/A'}</td>
                <td>${convertUTCDateToLocalDate(item.created_at)}</td>
              </tr>
            `).join('')}
            <tr class="total-row">
              <td colspan="4">TOTAL</td>
              <td>${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format(totalAmount)}</td>
              <td colspan="2">${data.length} transactions</td>
            </tr>
          </tbody>
        </table>
      </body>
      </html>
    `;

    // Open in new window for printing/saving
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(reportHTML);
      printWindow.document.close();
      printWindow.focus();
    }
  };

  // Export Data
  const exportData = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoader(true);

    if (!exportFromDate || !exportToDate) {
      toast.error('Please select date range for export');
      setLoader(false);
      return;
    }

    const query = {
      search: '',
      from: exportFromDate,
      to: exportToDate,
      limit: 50000 // High limit for exports
    };

    // Use the new export endpoint instead of the paginated one
    SuperAdminApis.exportAllExpenses(query).then((response: AxiosResponse<any>) => {
      if (response?.data?.status) {
        const expenseData = response?.data?.data || [];

        if (expenseData.length === 0) {
          toast.warning('No data found for the selected date range');
          setLoader(false);
          setExportModal(false);
          return;
        }

        if (exportFormat === 'csv') {
          exportToCSV(expenseData);
        } else if (exportFormat === 'excel') {
          exportToExcel(expenseData);
        }

        setLoader(false);
        setExportModal(false);
        toast.success(`Successfully exported ${expenseData.length} records as ${exportFormat.toUpperCase()}`);

        // Log export details
        console.log(`Export completed: ${expenseData.length} records from ${exportFromDate} to ${exportToDate}`);
      } else {
        setLoader(false);
        toast.error('No data available for export');
        setExportModal(false);
      }
    }).catch((error) => {
      setLoader(false);
      console.error('Export error:', error);
      const errorMessage = error.response?.data?.message || 'Failed to export data';
      toast.error(errorMessage);
      setExportModal(false);
    });
  }, [exportFormat, exportFromDate, exportToDate]);



  // Export to CSV
  const exportToCSV = (data: any[]) => {
    try {
      const csvHeaders = ['S/N', 'Invoice ID', 'Expense Type', 'Email', 'Amount (NGN)', 'Status', 'Date'];

      // Map the data to match our headers
      const csvRows = data.map((item, index) => [
        index + 1,
        item.invoice_id || 'N/A',
        item.shipment_id || 'Expense Voucher',
        item.user_email || 'N/A',
        parseFloat(item.amount) || 0,
        item.payment_status || 'N/A',
        convertUTCDateToLocalDate(item.created_at) || 'N/A'
      ]);

      const csvContent = [
        csvHeaders.join(','),
        ...csvRows.map(row =>
          row.map(cell => {
            // Handle special characters in CSV
            const cellStr = String(cell);
            if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
              return `"${cellStr.replace(/"/g, '""')}"`;
            }
            return cellStr;
          }).join(',')
        )
      ].join('\n');

      // Add BOM for proper UTF-8 encoding in Excel
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `expense_export_${exportFromDate}_to_${exportToDate}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Cleanup
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error('CSV export error:', error);
      toast.error('Failed to export CSV file');
    }
  };

  // Export to Excel (basic HTML table format)
  const exportToExcel = (data: any[]) => {
    try {
      const totalAmount = data.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);

      const excelContent = `
      <html>
        <head>
          <meta charset="UTF-8">
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid #000; padding: 8px; text-align: left; }
            th { background-color: #E04343; color: white; font-weight: bold; }
            .header { font-weight: bold; font-size: 16px; margin-bottom: 10px; }
            .total { background-color: #f0f0f0; font-weight: bold; }
            .amount { text-align: right; }
          </style>
        </head>
        <body>
          <div class="header">Expense Data Export</div>
          <div>Period: ${exportFromDate} to ${exportToDate}</div>
          <div>Generated: ${new Date().toLocaleDateString()}</div>
          <div>Total Records: ${data.length}</div>
          <br/>
          
          <table>
            <tr>
              <th>S/N</th>
              <th>Invoice ID</th>
              <th>Expense Type</th>
              <th>Email</th>
              <th>Amount (NGN)</th>
              <th>Status</th>
              <th>Date</th>
            </tr>
            ${data.map((item, index) => `
              <tr>
                <td>${index + 1}</td>
                <td>${item.invoice_id || 'N/A'}</td>
                <td>${item.shipment_id || 'Expense Voucher'}</td>
                <td>${item.user_email || 'N/A'}</td>
                <td class="amount">${parseFloat(item.amount) || 0}</td>
                <td>${item.payment_status || 'N/A'}</td>
                <td>${convertUTCDateToLocalDate(item.created_at) || 'N/A'}</td>
              </tr>
            `).join('')}
            <tr class="total">
              <td colspan="4">TOTAL</td>
              <td class="amount">${totalAmount.toFixed(2)}</td>
              <td colspan="2">${data.length} records</td>
            </tr>
          </table>
        </body>
      </html>
    `;

      const blob = new Blob([excelContent], {
        type: 'application/vnd.ms-excel;charset=utf-8;'
      });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', `expense_export_${exportFromDate}_to_${exportToDate}.xls`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Cleanup
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Excel export error:', error);
      toast.error('Failed to export Excel file');
    }
  };

  // Get current month and year for default values
  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const months = [
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const years = [];
  for (let year = currentYear; year >= currentYear - 10; year--) {
    years.push(year.toString());
  }

  return (
    <>
      <AdminSidebar title="Expenses" />
      <div className="relative md:ml-64 bg-[#FAFAFA] ">
        <AdminNavbar title="Expenses" />
        <div className=' lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen'>

          <div className='grid grid-cols-1 md:flex justify-between gap-3 mb-4'>
            <div>
              <h3 className='text-[15px] text-[#1C1C1C] font-semibold'>Expense&nbsp;List</h3>
            </div>
            <span></span><span></span> <span></span><span></span> <span></span><span></span>

            <div className="flex gap-2">
              <button
                onClick={() => setReportModal(true)}
                className='bg-[#28a745] text-white text-[14px] px-[12px] py-[8px] rounded-[10px]'>
                📊 Generate Report
              </button>
              <button
                onClick={() => setExportModal(true)}
                className='bg-[#17a2b8] text-white text-[14px] px-[12px] py-[8px] rounded-[10px]'>
                📥 Export Data
              </button>
              <button
                onClick={() => setInvoiceModal(true)}
                className='bg-[#E04343] text-white text-[14px] px-[12px] py-[8px] rounded-[10px]'>
                📧 Send Invoice
              </button>
            </div>
          </div>

          <div className='grid grid-cols-1 md:flex justify-between gap-3'>
            <div className=" flex justify-start w-full gap-2">
              <h2 className='text-sm '>From: &nbsp;</h2>
              <span className='w-full'>
                <input type="date" onChange={e => setFrom(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md  w-full pl-4 py-1 px-4  " required />
              </span>
            </div>

            <div className=" flex justify-start w-full">
              <span className='text-sm'>To: &nbsp;</span>
              <span className='w-full'>
                <input type="date" onChange={e => setTo(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md  w-full pl-4 px-4 py-1  " required />
              </span>
            </div>

            <div className="relative flex w-full ">
              <span className='w-full'>
                <input type="text" onChange={e => setSearchText(e.target.value)} placeholder='search...' className=" border border-gray-300 text-gray-500 text-sm rounded-md  w-full pl-4 px-4 py-1  " required />
              </span>
            </div>

            <div className='flex justify-between'>
              <div className='mt-0.5 ml-2'>
                <button type='button' onClick={() => paginator('')} className={"font-normal text-white bg-[#E04343] px-3 py-0.5 rounded-md"}>
                  Search
                </button>
              </div>
            </div>
          </div>

          <div className="relative overflow-x-auto mt-4">
            {loader ? (
              <div className='flex justify-center my-3 mt-20 pb-10'>
                <Oval
                  visible={true}
                  height="80"
                  width="80"
                  color="#E04343"
                  secondaryColor="#FF3B300D"
                  ariaLabel="oval-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 border-separate border-spacing-y-3">
                <thead className="text-[12px] text-[#808080] bg-[#FAFAFA] ">
                  <tr>
                    <th scope="col" className="px-2 py-2">S/N</th>
                    <th scope="col" className="px-2 py-2">Invoice ID</th>
                    <th scope="col" className="px-2 py-2">Expense Type</th>
                    <th scope="col" className="px-2 py-2">Created By</th>
                    <th scope="col" className="px-2 py-2">Approved By</th>
                    <th scope="col" className="px-2 py-2">Amount</th>
                    <th scope="col" className="px-2 py-2">Date</th>
                    <th scope="col" className="px-4">Status</th>
                  </tr>
                </thead>

                <tbody className=''>
                  {userLists?.data?.length > 0 ?
                    userLists?.data?.map((datas: any, index: any) => (
                      <tr key={index} className="bg-white  ">
                        <td className="px-2 py-2">{index + 1}</td>
                        <td className="px-2 ">{datas?.invoice_id}</td>
                        <td className="px-2 ">{datas?.shipment_id}</td>
                        <td className="px-2 ">{datas?.customer_service_email}</td>
                        <td className="px-2 ">{datas?.user_email}</td>
                        <td className="px-2  ">
                          {(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN' }).format((datas?.amount) ? (datas?.amount) : 0.0))}
                        </td>
                        <td className="px-2  ">{convertUTCDateToLocalDate(datas?.created_at)}</td>
                        <td className="px-2 ">
                          {datas?.payment_status == 'successful' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#C9F0D0', color: '#51CF66', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                          {datas?.payment_status == 'pending' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#FFDDBD', color: '#FF922B', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                          {datas?.payment_status == 'failed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#E6BDFF', color: '#B24BF1', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                          {datas?.payment_status == 'Missed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                          {datas?.payment_status == 'Closed' ? <p><b style={{ fontWeight: "500", fontSize: '14px', backgroundColor: '#CAD8FA', color: '#4979ED', borderRadius: '10px', padding: '2px 10px' }}>{datas?.payment_status}</b></p> : ''}
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan={7} className='flex justify-start mt-4'>
                          No Record Found
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            )}
          </div>

          <div className='m-4 flex justify-end mt-20'>
            {userLists?.links?.filter(((item: any, idx: any) => idx < 1000)).map((datas: any, index: any) => (
              <button
                key={index}
                onClick={() => paginator(datas?.label == 'Next &raquo;' ? datas?.url?.charAt(datas?.url?.length - 1) : (datas?.label === '&laquo; Previous') ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)}
                disabled={datas?.active}
                className={'mx-1 py-1 px-2 ' + ((datas?.active == false || datas?.url == null) ? 'bg-gray-300 text-black ' : 'bg-[#E04343] text-white')}>
                {datas?.label == '&laquo; Previous' ? '< Previous' : (datas?.label === 'Next &raquo;') ? 'Next  >' : datas?.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Invoice Modal */}
      <section>
        <Modal
          visible={invoiceModal}
          width="550"
          height="500"
          effect="fadeInUp"
          onClickAway={() => setInvoiceModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>
            <div className="container  bg-[#fff] rounded-lg p-2">
              <span className="flex justify-between px-2 pt-1">
                <p className='mt-2 font-bold'>Generate Invoice</p>
                <p className="cursor-pointer font-bold" onClick={(e) => setInvoiceModal(false)}><SvgElement type={icontypesEnum.CANCEL} /></p>
              </span>

              <form onSubmit={generateInvoice}>
                <div className="flex flex-col lg:flex-row lg:justify-between max-w-screen-xl mx-auto  mt-5">
                  <div className="relative flex flex-col min-w-0 break-words w-full  ">
                    <div className="flex-auto   py-10 pt-0">
                      <div className="flex flex-wrap ">
                        <div className="lg:w-12/12 w-full lg:pr-4">
                          <div className="flex justify-between mb-3">
                            <label className="text-[#333333] text-[12px]">From</label>
                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                          </div>
                          <div className="relative mb-4">
                            <input type="date" onChange={e => setFromDate(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 p-2  " required />
                          </div>
                        </div>

                        <div className="lg:w-12/12 w-full lg:pr-4">
                          <div className="flex justify-between mb-3">
                            <label className="text-[#333333] text-[12px]">To</label>
                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                          </div>
                          <div className="relative mb-4">
                            <input type="date" onChange={e => setToDate(e.target.value)} placeholder='' className=" border border-gray-300 text-gray-500 text-sm rounded-md block w-full pl-4 p-2  " required />
                          </div>
                        </div>

                        <div className="lg:w-12/12 w-full lg:pr-4">
                          <div className="flex justify-between mb-3">
                            <label className="text-[#333333] text-[12px] font-[400]">Email</label>
                            <SvgElement type={icontypesEnum.QUESTIONMARK} />
                          </div>
                          <div className="relative mb-4">
                            <input type="email" name="email" onChange={e => setUserEmail(e.target.value)} className=" border border-[#D1D1D1] text-gray-900 text-sm rounded-[5px] block w-full pl-6 p-2" placeholder="john@gmail.com" required />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button type="submit" className="text-white bg-[#E04343] rounded-[30px] w-full transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px]">Generate Invoice</button>
              </form>
            </div>
          </div>
        </Modal>
      </section>

      {/* Report Generation Modal */}
      <section>
        <Modal
          visible={reportModal}
          width="600"
          height="600"
          effect="fadeInUp"
          onClickAway={() => setReportModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>
            <div className="container bg-[#fff] rounded-lg p-4">
              <span className="flex justify-between px-2 pt-1 mb-4">
                <p className='mt-2 font-bold'>Generate Expense Report</p>
                <p className="cursor-pointer font-bold" onClick={() => setReportModal(false)}>
                  <SvgElement type={icontypesEnum.CANCEL} />
                </p>
              </span>

              <form onSubmit={generateReport}>
                <div className="mb-4">
                  <label className="block text-[#333333] text-[14px] font-semibold mb-2">Report Type</label>
                  <select
                    value={reportType}
                    onChange={(e) => setReportType(e.target.value)}
                    className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                  >
                    <option value="monthly">Monthly Report</option>
                    <option value="custom">Custom Date Range</option>
                  </select>
                </div>

                {reportType === 'monthly' && (
                  <>
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <label className="block text-[#333333] text-[12px] mb-2">Month</label>
                        <select
                          value={reportMonth}
                          onChange={(e) => setReportMonth(e.target.value)}
                          className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                          required
                        >
                          <option value="">Select Month</option>
                          {months.map(month => (
                            <option key={month.value} value={month.value}>{month.label}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-[#333333] text-[12px] mb-2">Year</label>
                        <select
                          value={reportYear}
                          onChange={(e) => setReportYear(e.target.value)}
                          className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                          required
                        >
                          {years.map(year => (
                            <option key={year} value={year}>{year}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                )}

                {reportType === 'custom' && (
                  <div className="grid grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-[#333333] text-[12px] mb-2">From Date</label>
                      <input
                        type="date"
                        value={customFromDate}
                        onChange={(e) => setCustomFromDate(e.target.value)}
                        className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-[#333333] text-[12px] mb-2">To Date</label>
                      <input
                        type="date"
                        value={customToDate}
                        onChange={(e) => setCustomToDate(e.target.value)}
                        className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                        required
                      />
                    </div>
                  </div>
                )}

                <div className="bg-[#f8f9fa] p-4 rounded-md mb-4">
                  <h4 className="font-semibold mb-2">Report Features:</h4>
                  <ul className="text-sm text-gray-600 list-disc list-inside">
                    <li>Complete expense summary for selected period</li>
                    <li>Total amount and transaction count</li>
                    <li>Detailed transaction breakdown</li>
                    <li>Print-friendly format</li>
                    <li>Professional styling</li>
                  </ul>
                </div>

                <button
                  type="submit"
                  disabled={loader}
                  className="text-white bg-[#28a745] rounded-[30px] w-full transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px] disabled:bg-gray-400"
                >
                  {loader ? (
                    <div className="flex justify-center gap-2 items-center">
                      <Oval height="20" width="20" color="#ffffff" secondaryColor="#cccccc" />
                      <span>Generating...</span>
                    </div>
                  ) : (
                    'Generate Report'
                  )}
                </button>
              </form>
            </div>
          </div>
        </Modal>
      </section>

      {/* Export Data Modal */}
      <section>
        <Modal
          visible={exportModal}
          width="600"
          height="500"
          effect="fadeInUp"
          onClickAway={() => setExportModal(false)}
        >
          <div className=" " style={{ height: '100%', overflow: 'auto' }}>
            <div className="container bg-[#fff] rounded-lg p-4">
              <span className="flex justify-between px-2 pt-1 mb-4">
                <p className='mt-2 font-bold'>Export Expense Data</p>
                <p className="cursor-pointer font-bold" onClick={() => setExportModal(false)}>
                  <SvgElement type={icontypesEnum.CANCEL} />
                </p>
              </span>

              <form onSubmit={exportData}>
                <div className="mb-4">
                  <label className="block text-[#333333] text-[14px] font-semibold mb-2">Export Format</label>
                  <select
                    value={exportFormat}
                    onChange={(e) => setExportFormat(e.target.value)}
                    className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                  >
                    <option value="csv">CSV (Comma Separated Values)</option>
                    <option value="excel">Excel (XLS)</option>
                  </select>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-[#333333] text-[12px] mb-2">From Date</label>
                    <input
                      type="date"
                      value={exportFromDate}
                      onChange={(e) => setExportFromDate(e.target.value)}
                      className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-[#333333] text-[12px] mb-2">To Date</label>
                    <input
                      type="date"
                      value={exportToDate}
                      onChange={(e) => setExportToDate(e.target.value)}
                      className="border border-gray-300 text-gray-500 text-sm rounded-md block w-full p-2"
                      required
                    />
                  </div>
                </div>

                <div className="bg-[#f8f9fa] p-4 rounded-md mb-4">
                  <h4 className="font-semibold mb-2">Export Information:</h4>
                  <ul className="text-sm text-gray-600 list-disc list-inside">
                    <li>Data will be exported in {exportFormat.toUpperCase()} format</li>
                    <li>Includes all expense transactions for selected date range</li>
                    <li>File will be automatically downloaded</li>
                    <li>CSV files can be opened in Excel or other spreadsheet applications</li>
                  </ul>
                </div>

                <button
                  type="submit"
                  disabled={loader}
                  className="text-white bg-[#17a2b8] rounded-[30px] w-full transition ease-out delay-300 py-[10px] px-[42px] font-[700] text-[14px] disabled:bg-gray-400"
                >
                  {loader ? (
                    <div className="flex justify-center gap-2 items-center">
                      <Oval height="20" width="20" color="#ffffff" secondaryColor="#cccccc" />
                      <span>Exporting...</span>
                    </div>
                  ) : (
                    `Export as ${exportFormat.toUpperCase()}`
                  )}
                </button>
              </form>
            </div>
          </div>
        </Modal>
      </section>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}

export default ManageExpense